import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FacebookShareButton from 'react-share/lib/FacebookShareButton';
import TwitterShareButton from 'react-share/lib/TwitterShareButton';
import RedditShareButton from 'react-share/lib/RedditShareButton';
import EmailShareButton from 'react-share/lib/EmailShareButton';

import copy from 'copy-to-clipboard';
import Icon from '../Icon';
import ClickableWrap from '../ClickableWrap';

import './styles.less';

const Share = (props) => {
    const renderFacebook = () => {
        return (
            <li className="p-share__item">
                <FacebookShareButton className="p-share__link p-share__link--facebook" url={props.content.url}>
                    <div className="p-share__icon">
                        <Icon icon="facebook" />
                    </div>
                </FacebookShareButton>
            </li>
        );
    };

    const renderTwitter = () => {
        return (
            <li className="p-share__item">
                <TwitterShareButton
                    className="p-share__link p-share__link--twitter"
                    title={props.content.twitterTitle}
                    url={props.content.url}
                    via={props.content.twitterHandle}
                >
                    <Icon icon="twitter" className="p-share__icon" />
                </TwitterShareButton>
            </li>
        );
    };

    const renderReddit = () => {
        return (
            <li className="p-share__item">
                <RedditShareButton className="p-share__link p-share__link--reddit" url={props.content.url}>
                    <Icon icon="reddit" className="p-share__icon" />
                </RedditShareButton>
            </li>
        );
    };

    const renderEmail = () => {
        return (
            <li className="p-share__item">
                <EmailShareButton
                    className="p-share__link p-share__link--email"
                    url={props.content.url}
                    subject={props.content.headline}
                    body={props.content.headline}
                >
                    <Icon icon="email" className="p-share__icon" />
                </EmailShareButton>
            </li>
        );
    };

    const renderPrint = () => {
        return (
            <li className="p-share__item" tabIndex="0">
                <ClickableWrap
                    className="p-share__link p-share__link--print"
                    onClick={() => window.open(props.content.printUrl)}
                >
                    <Icon icon="printer" className="p-share__icon" />
                </ClickableWrap>
            </li>
        );
    };

    const renderEmbed = () => {
        return (
            <li className="p-share__item" tabIndex="0">
                <ClickableWrap
                    className="p-share__link p-share__link--embed"
                    onClick={() => copy(props.content.url, { message: 'Press #{key} to copy' })}
                >
                    <Icon icon="embed" className="p-share__icon" />
                </ClickableWrap>
            </li>
        );
    };

    const renderCopy = () => {
        return (
            <li className="p-share__item" tabIndex="0">
                <ClickableWrap
                    className="p-share__link p-share__link--copy"
                    onClick={() => copy(props.content.url, { message: 'Press #{key} to copy' })}
                >
                    <Icon icon="link" className="p-share__icon" />
                </ClickableWrap>
            </li>
        );
    };

    return (
        <div
            className={classNames({
                'p-share': true,
                [`p-share--${props.contentId}`]: props.contentId,
                [props.className]: props.className
            })}
            data-cid={props.contentId}
        >
            <div className="p-share__buttons-container">
                <ul className="p-share__list">
                    {props.networks.facebook && props.content.url ? renderFacebook() : null}
                    {props.networks.twitter && props.content.url ? renderTwitter() : null}
                    {props.networks.reddit && props.content.url ? renderReddit() : null}
                    {props.networks.email && props.content.url ? renderEmail() : null}
                    {props.networks.print && props.content.printUrl ? renderPrint() : null}
                    {props.networks.embed && props.content.embed ? renderEmbed() : null}
                    {props.networks.copy && props.content.url ? renderCopy() : null}
                </ul>
            </div>
        </div>
    );
};

Share.propTypes = {
    contentId: PropTypes.string,
    className: PropTypes.string,
    content: PropTypes.shape({
        headline: PropTypes.string,
        blurb: PropTypes.string,
        url: PropTypes.string,
        printUrl: PropTypes.string,
        embed: PropTypes.string,
        twitterHandle: PropTypes.string,
        twitterTitle: PropTypes.string
    }),
    networks: PropTypes.shape({
        facebook: PropTypes.bool,
        twitter: PropTypes.bool,
        reddit: PropTypes.bool,
        email: PropTypes.bool,
        print: PropTypes.bool,
        embed: PropTypes.bool,
        copy: PropTypes.bool
    })
};

Share.defaultProps = {
    contentId: undefined,
    className: undefined,
    content: {
        headline: undefined,
        blurb: undefined,
        url: undefined,
        printUrl: undefined,
        embed: undefined,
        twitterHandle: undefined,
        twitterTitle: undefined
    },
    networks: {
        facebook: false,
        twitter: false,
        reddit: false,
        email: false,
        print: false,
        embed: false,
        copy: false
    }
};

export default Share;
